import { render, staticRenderFns } from "./DistributionDetail.vue?vue&type=template&id=1b09db6f&scoped=true&"
import script from "./DistributionDetail.vue?vue&type=script&lang=js&"
export * from "./DistributionDetail.vue?vue&type=script&lang=js&"
import style0 from "./DistributionDetail.vue?vue&type=style&index=0&id=1b09db6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09db6f",
  null
  
)

export default component.exports